/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'product': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M387.332 118.736H187.717c-39.284 0-71.13 31.846-71.13 71.13v198.93c0 39.284 31.846 71.13 71.13 71.13h199.615c39.284 0 71.13-31.846 71.13-71.13v-198.93c0-39.284-31.845-71.13-71.13-71.13zM387.332 562.988H187.717c-39.284 0-71.13 31.846-71.13 71.13v198.93c0 39.284 31.846 71.13 71.13 71.13h199.615c39.284 0 71.13-31.846 71.13-71.13v-198.93c0-39.284-31.845-71.13-71.13-71.13zM930.62 683.527l-141.15-141.15c-27.778-27.778-72.815-27.778-100.593 0L548.212 683.042c-27.778 27.778-27.778 72.815 0 100.593l141.149 141.149c27.778 27.778 72.815 27.778 100.593 0l140.665-140.665c27.778-27.777 27.778-72.815.001-100.592zM638.517 459.925h199.615c39.284 0 71.13-31.846 71.13-71.13V189.864c0-39.284-31.846-71.13-71.13-71.13H638.517c-39.284 0-71.13 31.846-71.13 71.13v198.93c0 39.284 31.845 71.131 71.13 71.131z"/>'
  }
})
